import { z } from 'zod';

export const vehicleTypeSchema = z.enum([
  'Auto',
  'RV',
  'Heavy Duty',
  'Bus',
  'Light Duty',
  'Medium Duty',
]);

export type VehicleType = z.infer<typeof vehicleTypeSchema>;
